<div class="d-flex flex-wrap gap-2 align-items-center justify-content-end w-100" [class.cbs-labelled]="showLabels">
    <div *ngIf="User.companyId == 1" [ngClass]="showLabels ? 'd-flex align-items-center gap-2' : ''">


        <ng-container *ngIf="userPermissionService.getUserPermission('CSDD')">
            <label *ngIf="showLabels" for="cbsCompany" class="small text-muted fw-medium mb-0 text-nowrap">Company</label>
            <select id="cbsCompany" class="form-select form-select-sm w-auto" [formControl]="tenantIdControl" (change)="onCompanyChange()">
                <option [value]="0">Show All Companies</option>
                <option *ngFor="let company of companyList" [value]="+company.key">
                    {{company.value}}
                </option>
            </select>
        </ng-container>



        <!-- <ng-select [items]="companyList" bindLabel="value" bindValue="key" placeholder="Select Company" (change)="onCompanyChange()" [formControl]="companyIdControl"> </ng-select> -->



        <app-form-errors [control]="tenantIdControl"></app-form-errors>

    </div>

    <div *ngIf="showBranchDropdown" [ngClass]="showLabels ? 'd-flex align-items-center gap-2' : ''">
        <label *ngIf="showLabels" for="cbsBranch" class="small text-muted fw-medium mb-0 text-nowrap">Branch</label>
        <select id="cbsBranch" class="form-select form-select-sm w-auto" [formControl]="tenantBranchIdControl" >
            <option [ngValue]="0">Show All Branches</option>
            <option *ngFor="let branch of branchList" [ngValue]="+branch.key">
                {{ branch.value }}
            </option>
        </select>
        <app-form-errors [control]="tenantBranchIdControl"></app-form-errors>

    </div>

    <div [ngClass]="showLabels ? 'd-flex align-items-center gap-2' : ''">
        <label *ngIf="showLabels" for="cbsSoftware" class="small text-muted fw-medium mb-0 text-nowrap">Software</label>
        <select id="cbsSoftware" class="form-select form-select-sm w-auto" [formControl]="softwareIdControl">
            <option [ngValue]="0">Show All Softwares</option>
            <option *ngFor="let software of softwareList" [ngValue]="+software.key">
                {{software.value}}
            </option>
        </select>
        <app-form-errors [control]="softwareIdControl"></app-form-errors>
    </div>
    <div>
        <button class="btn btn-primary btn-sm" [disabled]="isLoading" (click)="submit()">Load</button>
    </div>
</div>